import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'
import { ReportsKpiMetric } from '@dataTypes/reports.type'

export const GOAL_ATTAINMENT_VARIANCE_FILTERS = REPORTS_DEFAULT_FILTERS

export const GOAL_ATTAINMENT_VARIANCE_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'currency' | 'percent'
}> = [
  {
    id: 'production-goal',
    title: 'Production Goal',
    footer: 'Current period goal',
    format: 'currency',
  },
  {
    id: 'production-actual',
    title: 'Production Actual',
    footer: 'Posted production this period',
    format: 'currency',
  },
  {
    id: 'collections',
    title: 'Collections',
    footer: 'Payments received this period',
    format: 'currency',
  },
  {
    id: 'production-variance',
    title: 'Variance (Production %)',
    footer: 'Actual vs. Goal',
    format: 'percent',
  },
]

/** @deprecated Use GOAL_ATTAINMENT_VARIANCE_KPI_DEFINITIONS with live API values */
export const GOAL_ATTAINMENT_VARIANCE_KPI_METRICS: ReportsKpiMetric[] =
  GOAL_ATTAINMENT_VARIANCE_KPI_DEFINITIONS.map((def) => ({
    id: def.id,
    title: def.title,
    footer: def.footer,
    value: '—',
  }))
